import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findStuff = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff?`+params,
        method: 'GET'
    })
}

export const findUserInfo = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff/userInfo`,
        method: 'GET'
    })
}

export const findStuffAll = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff/choose`,
        method: 'GET'
    })
}

export const addStuff = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff`,
        method: 'POST',
        data: data
    })
}
// 添加新员工表单动态字段
export const findRosterField = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/roster/findRosterField`,
        method: 'GET',
        data: data
    })
}
// 添加新员工
export const addRoster = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff/add`,
        method: 'POST',
        data: data
    })
}
//获取员工信息
export const getEditRoster = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/roster/findRosterFieldContent/${data}`,
        method: 'GET',
        data: data
    })
}
//获取员工异动信息
export const getStuffChangeInfo = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff/stuffChangeInfo/${data}`,
        method: 'GET',
        data: data
    })
}
//修改员工信息
export const updateRoster = (data,id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff/dingTalkHmc/${id}`,
        method: 'PUT',
        data: data
    })
}
export const addStuffAgent = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff/agent`,
        method: 'POST',
        data: data
    })
}

export const editStuff = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff`,
        method: 'PUT',
        data: data
    })
}

export const delStuff = (deleteOption, ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff/${temp}?option=${deleteOption}`,
        method: 'DELETE'
    })
}
export const chaStuff = (selectStuffIds, params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff/${selectStuffIds}`+'?'+params,
        method: 'PUT'
    })
}